import { gql } from "@apollo/client";

export const customerStatisticsDetailsFragment = gql`
  fragment CustomerStatisticsDetails on Customer {
    id
    name
    breadCrumbName
    custIndex
    custNo
    isParent
    custStatus {
      id
      name
    }
    parent {
      id
      preselectedHeadAgreement {
        id
      }
    }
    childCustomers {
      id
    }
    statisticalGrouping {
      id
    }
    invoiceCurrency {
      id
      code
    }
    seller {
      id
      name
    }
    salesRegion {
      id
      code
      name
    }
    isStandardCustomer
    hasRebateAgreements
    writeHistory {
      createdAt {
        isoString
      }
      createdBy {
        id
        name
      }
      modifiedAt {
        isoString
      }
      modifiedBy {
        id
        name
      }
    }
  }
`;

export const threeYearsStatisticsCustomerDetailsFragment = gql`
  fragment ThreeYearsTargetActual on ThreeYearsTargetAndActual {
    routePairCode
    year
    targetInPercent
    actualOutcomeInPercent
  }

  fragment ThreeYearsPricePerMeter on ThreeYearsPricePerMeter {
    routePairCode
    year
    pricePerMeter
  }

  fragment ThreeYearsVolumeExpected on ThreeYearsVolumeAndExpected {
    routePairCode
    year
    volume
    expectedVolume
  }
`;
